$ ->
  update_alert_visibility = ->
    show_selected_services()
    hide_empty_alert_sections()
    update_alert_links()

  selected_services = ->
    $('.js-search-alert-service:checked')

  show_selected_services = ->
    services = selected_services()

    if services.length
      unselected_alerts = $('.SearchAlerts-item')

      services.each ->
        selector = ".AlertService-#{$(this).val()}"
        unselected_alerts = unselected_alerts.not(selector)

      unselected_alerts.addClass 'SearchAlerts-item--hidden'

      $('.SearchAlerts-item')
        .not unselected_alerts
        .removeClass 'SearchAlerts-item--hidden'

    else
      $('.SearchAlerts-item').removeClass 'SearchAlerts-item--hidden'

  hide_empty_alert_sections = ->
    # Make visible any list that has at least one visible alert.
    visible = $('.SearchAlerts')
      .has '.SearchAlerts-item:not(.SearchAlerts-item--hidden, .SearchAlerts-item--not-matching)'
      .removeClass 'SearchAlerts--none-matching'

    # Make hidden any list that has no visible alerts.
    $('.SearchAlerts')
      .not visible
      .addClass 'SearchAlerts--none-matching'

  update_alert_links = ->
    service_names = _.map(
      selected_services()
      (input) -> $(input).val()
    ).join ','

    return_to = encodeURIComponent("#{window.location.pathname}")

    if service_names.length
      return_to += encodeURIComponent("?selected=#{service_names}")

    $('.SearchAlerts-item a').each ->
      link      = $ this
      base_href = link.data 'base_href'

      unless base_href
        base_href = link.attr 'href'
        link.data 'base_href', base_href

      link.attr 'href', "#{base_href}?return_to=#{return_to}"

  alert_services = $('.js-search-alert-service')
  if alert_services.length
    update_alert_visibility()
    alert_services.change update_alert_visibility

  searchbox = $('#alert-searchbox')
  if searchbox.length
    searchbox.liveFilter '.SearchAlerts > ul',
                         'SearchAlerts-item--not-matching',
                         hide_empty_alert_sections
